import styled from '@emotion/styled';
import { media } from '@/styles/tokens';

export const Container = styled.div`
  background-color: #03095c;
`;
export const Inner = styled.div`
  padding: 7.56rem 0 7.56rem 78px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;

  ${media.mobile} {
    padding: 60px 0;
    flex-direction: column-reverse;
    max-width: 375px;
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  ${media.mobile} {
    align-items: center;
  }
`;
export const Title = styled.h1`
  margin-top: 1rem;
  color: #fff;
  font-size: 3rem;
  font-weight: 700;
  line-height: 3.875rem;
  letter-spacing: -0.0625rem;

  ${media.mobile} {
    margin-top: 1.75rem;
    color: #fff;
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.375rem;
    text-align: center;
  }
`;
export const Description = styled.p`
  margin-top: 1.5rem;
  color: #efefef;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.75rem;
  white-space: pre-line;

  ${media.mobile} {
    margin-top: 0.62rem;
    font-size: 0.9375rem;
    line-height: 1.375rem;
    text-align: center;
  }
`;

export const Btn_CTA = styled.button`
  margin-top: 40px;
  padding: 15px 32px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  background-color: #3449ff;
  border: none;
  border-radius: 8px;
`;
export const AIImage = styled.div`
  position: relative;
  width: 40.7rem;
  height: 26.1rem;

  ${media.mobile} {
    width: 100%;
    height: 13.8rem;
  }
`;
